import React, { useState } from 'react';
import {
  FDAlert, FDBodyText, FDBox, FDSecondaryActionIconButton,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import { DataValueMap } from 'Helpers/Testing';
import { makeStyles } from 'Components/ComponentLibrary/Styles';
import { MobileStepper } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import theme from 'Theme';
import { useSnackbarContext } from 'Context/SnackbarContext';

const useStyles = makeStyles({
  mobileStepper: {
    background: 'transparent',
    padding: 0,
    fontSize: theme.typography.subtitle1.fontSize,
  },
});

const MemberDataCaptureStepper = ({ resource, setPage }) => {
  const classes = useStyles();
  const { displayErrorMessage } = useSnackbarContext();
  const [loadingPrevious, setLoadingPrevious] = useState(false);
  const [loadingNext, setLoadingNext] = useState(false);

  const activeStep = Number(resource.attr('currentSectionNumber'));
  const steps = Number(resource.attr('totalSections'));

  const hasPreviousStep = !!resource.relationship(fr.relationships.previousLink.name);
  const hasNextStep = !!resource.relationship(fr.relationships.nextLink.name);

  async function fetchPage(pageLink, page) {
    if (!page) {
      setLoadingPrevious(true);
      setLoadingNext(true);
    }
    if (page === 'previous') {
      setLoadingPrevious(true);
    }
    if (page === 'next') {
      setLoadingNext(true);
    }
    try {
      setPage(await pageLink.get());
    } catch (e) {
      displayErrorMessage(e, e.errors[0]?.detail || 'Unable to proceed. Please try again later.');
    } finally {
      setLoadingPrevious(false);
      setLoadingNext(false);
    }
  }

  return (
    <>
      {resource.attr('status') === 'COMPLETE' && (
      <FDAlert
        {...DataValueMap.init('member-data-capture-complete').build()}
        status={'success'}
        title={resource.attr('statusTitle')}
        description={resource.attr('statusMessage')}
      />
      )}
      <FDBox padding={100}>
        {resource.attr('description') && <FDBodyText
          {...DataValueMap.init('member-data-capture-description').build()}
          align={'center'}
          value={resource.attr('description')}
        />}
      </FDBox>
      {(hasPreviousStep || hasNextStep) && <MobileStepper
        {...DataValueMap.init('mdc-mobile-stepper').build()}
        className={classes.mobileStepper}
        position={'static'}
        backButton={hasPreviousStep
          ? <FDSecondaryActionIconButton
            {...DataValueMap.init('mdc-mobile-stepper-prev').build()}
            size={'lg'}
            icon={'chevronLeft'}
            disabled={loadingPrevious || loadingNext}
            loading={loadingPrevious}
            onClick={() => fetchPage(resource.relationship(fr.relationships.previousLink.name).link('related'), 'previous')}
          />
          : <div />}
        nextButton={hasNextStep
          ? <FDSecondaryActionIconButton
            {...DataValueMap.init('mdc-mobile-stepper-next').build()}
            size={'lg'}
            icon={'chevronRight'}
            disabled={loadingPrevious || loadingNext}
            loading={loadingNext}
            onClick={() => fetchPage(resource.relationship(fr.relationships.nextLink.name).link('related'), 'next')}
          />
          : <div />}
        activeStep={activeStep}
        steps={steps}
        variant={steps < 20 ? 'dots' : 'text'}
      />}
    </>
  );
};

MemberDataCaptureStepper.defaultProps = {};

MemberDataCaptureStepper.propTypes = {};

export { MemberDataCaptureStepper };
